module.exports = __webpack_public_path__ + "img/notview.1cb5e17d.svg";